import {Store, Middleware} from 'redux'
import {BIReporter} from './BIReporter'
import {biErrorCodes} from './BIErrors'
import {
  BITrackingServicesList, IBIConfig, IBIEventObj, ITrackingService
} from 'powtoon-commons/biTracker/types'

// TODO finish all typings for BIEventTracker and BIActionTracker and remove any from all places here
// @ts-ignore
import {BIEventTracker} from './BIEventTracker'
// @ts-ignore
import {BIActionTracker} from './BIActionTracker'

export default class BITracker {

  private readonly _logger: any
  private readonly _reporter: BIReporter
  private _store: Store | null
  private _actionTracker: BIActionTracker
  private _eventTracker: BIEventTracker

  constructor(trackingService: ITrackingService, logger: any) {
    this._store = null
    this._logger = logger
    this._reporter = new BIReporter(logger, trackingService)
    this._actionTracker = new BIActionTracker(this._reporter)
    this._eventTracker = new BIEventTracker(this._reporter)
  }

  BIMiddleware = (store: Store): ReturnType<Middleware> => {
    this.setStore(store)
    return next => action => {
      const lastBITarget = this._eventTracker.getLastBITarget()
      this._actionTracker.actionHandler(action, store.getState(), lastBITarget)
      return next(action)
    }
  }

  setStore = (store: Store) => {
    this._store = store
    this._reporter.setStore(store)
    this._eventTracker.setStore(store)
  }

  config = (biConfig: IBIConfig) => {
    try {
      this._reporter.config(biConfig.reportEnhancers)
      this._actionTracker.config(biConfig.actionEvents)
      this._eventTracker.config(biConfig.domEvents)
    } catch (error) {
      this._reporter.logError(new Error('Error during biTracker config'),
        {errorCode: biErrorCodes.configurationError, error})
    }
  }

  public addDefaultTrackingService = (trackingService: ITrackingService) => {
    this._reporter.addDefaultTrackingService(trackingService)
  }

  public addRegularTrackingService = (trackingServiceId: BITrackingServicesList, trackingService: ITrackingService) => {
    this._reporter.addRegularTrackingService(trackingServiceId, trackingService)
  }


  reportCustomEvent = (event: IBIEventObj) => this._reporter.reportEvent(event)
}
